import React from "react";
import { Route, Routes, Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import PermissionMain from "../Components/Permissions/permissionMain";

const PermissionRoutes = () => {

  const currentRole = useSelector((state) => state?.admin?.admin?.data?.role)
  console.log("Role", currentRole)


  return (
    <Routes>
      <Route
        path="/permissions"
        element={
          currentRole === "super_admin"
            ? <PermissionMain />
            : <Navigate to="/dashboard" replace />
        }
      />
    </Routes>
  );
};

export default PermissionRoutes;
